import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { formatDate } from "@/lib/format";
import { cn } from "@/lib/utils";
import { SrIcon } from "@/components/ui/SrIcon";

export function DeadlineBadge({ deadline }: { deadline: string | null }) {
  if (!deadline) return <span className="text-[11px] text-gray-300">—</span>;

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const dueDate = new Date(deadline);
  dueDate.setHours(0, 0, 0, 0);
  const isOverdue = dueDate < today;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div className={cn(
          "inline-flex items-center gap-1 px-2.5 py-1 rounded-md text-[11px] font-medium",
          isOverdue ? "bg-red-100 text-red-700" : "bg-blue-100 text-blue-700"
        )}>
          <SrIcon name="calendar-days" className="w-3 h-3"  />
          <span>{formatDate(deadline)}</span>
        </div>
      </TooltipTrigger>
      <TooltipContent side="top" className="text-xs">
        {isOverdue ? "Sluttfaktura passert" : "Est. slutt faktura"}
      </TooltipContent>
    </Tooltip>
  );
}
